<script>
export default {
  props: {
    text: {
      type: String,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      company: this.$store.getters["company/getCompany"] || null,
    };
  },
  methods: {
    goRegisterPage() {
      if (this.company) {
        window.location.href = `/forms/editar-empresa/${this.company.uuid}`;
      }
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="row align-middle text-center">
            <div class="col-sm-12 col-md-6 text-md-right text-sm-center">
              <img src="@/assets/images/business.png" id="tooltip" height="100%" width="50%" alt="business" />
            </div>
            <div v-if="company.company_classification_id === 5
              " class="col-sm-12 col-md-6 align-middle text-left pt-3">
              <h2>Antes que nada,</h2>
              <h5 v-if="!text">
                se necesita que se actualice la información de la empresa
                {{ company.social_reason }} dentro del sistema.
              </h5>
              <h5 v-else>
                {{ text }}
              </h5>
              <button v-if="company" class="btn btn-primary" @click="goRegisterPage">
                Actualiza la empresa
              </button>
            </div>
            <!-- <div v-else-if="company.company_classification_id && company.company_classification_id < 4
              " class="col-sm-12 col-md-6 align-middle text-left pt-3">
              <h2>Lamentamos notificarte que,</h2>
              <h5>
                la empresa {{ company.social_reason }} ha sido clasificada como
                grupo III. Por favor comuníquese con nuestra área de soporte.
              </h5>
            </div> -->
            <!-- <div v-else class="col-sm-12 col-md-6 align-middle text-left pt-3">
              <h2>Antes que nada,</h2>
              <h5>
                se necesita que se actualice la información de la empresa
                {{ company.social_reason }} dentro del sistema.
              </h5>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
